export default __webpack_public_path__ + "static/media/tinylittle.96b345cf.mp3";